export const LAND_STATUS = {
  DRAFT: ["Draft", "bg-slate-100 text-slate-700 border-slate-200"],
  AVAILABLE: ["Tersedia", "bg-emerald-50 text-emerald-700 border-emerald-200"],
  PARTIAL: ["Sebagian Terpakai", "bg-amber-50 text-amber-800 border-amber-200"],
  USED: ["Terpakai", "bg-blue-50 text-blue-700 border-blue-200"],
  INACTIVE: ["Nonaktif", "bg-red-50 text-red-700 border-red-200"],
};
export const LAND_CATEGORY = {
  A_GROUP_CONTROLLED: "A · Dikuasai/disediakan Kelompok Tani/Koperasi (termasuk penyerahan hak kelola Ninik Mamak)",
  B_INDIVIDUAL_ENTRUSTED: "B · Milik perorangan yang dipercayakan untuk dikelola",
};
export const LAND_CATEGORY_SHORT = { A_GROUP_CONTROLLED: "Kategori A · Dikuasai Kelompok", B_INDIVIDUAL_ENTRUSTED: "Kategori B · Milik Perorangan" };
export const OWNERSHIP = {
  HAK_ULAYAT_NINIK_MAMAK: "Tanah ulayat - penyerahan hak kelola Ninik Mamak", HAK_KELOLA_KELOMPOK: "Hak kelola Kelompok Tani/Koperasi",
  HAK_MILIK_PERORANGAN: "Hak milik perorangan", SEWA: "Sewa", PINJAM_PAKAI: "Pinjam pakai", LAINNYA: "Lainnya",
};
export const HISTORY_LABELS = {
  CREATED: "Lahan dibuat", UPDATED: "Data diperbarui", PUBLISHED: "Dipublikasikan", UNPUBLISHED: "Publikasi ditarik (kembali Draft)",
  INACTIVE: "Dinonaktifkan", ACTIVE: "Diaktifkan kembali", PROJECT_CREATED: "Rencana Kebun dibuat",
};
export const n = (v) => Number(v || 0).toLocaleString("id-ID");
export const fileUrl = (id) => `${process.env.REACT_APP_BACKEND_URL}/api/land-files/${id}`;

export const LandStatusPill = ({ status, testid }) => {
  const [label, cls] = LAND_STATUS[status] || [status || "-", LAND_STATUS.DRAFT[1]];
  return <span className={`inline-flex w-fit items-center border font-bold px-2.5 py-0.5 rounded-full text-xs whitespace-nowrap ${cls}`} data-testid={testid}>{label}</span>;
};

export const CapacityBar = ({ land, testid }) => {
  const cap = land.capacity || 0;
  const used = land.usedTrees || 0;
  const pct = cap ? Math.min(100, (used / cap) * 100) : 0;
  return (
    <div data-testid={testid}>
      <div className="flex justify-between text-xs text-slate-600"><span>Terpakai {n(used)} / {n(cap)} batang</span><b className="text-emerald-800">Sisa {n(land.remainingTrees)}</b></div>
      <div className="mt-1 h-2 rounded-full bg-slate-100 overflow-hidden"><div className="h-full bg-emerald-700" style={{ width: `${pct}%` }} /></div>
    </div>
  );
};
